var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.5C0 8.58594 8.01562 0.5 18 0.5C27.9141 0.5 36 8.58594 36 18.5C36 28.4844 27.9141 36.5 18 36.5C8.01562 36.5 0 28.4844 0 18.5ZM12.3047 15.1953L15.6094 18.5L12.3047 21.8047C11.6016 22.5078 11.6016 23.5625 12.3047 24.1953C12.9375 24.8984 13.9922 24.8984 14.625 24.1953L17.9297 20.8906L21.3047 24.1953C21.9375 24.8984 22.9922 24.8984 23.625 24.1953C24.3281 23.5625 24.3281 22.5078 23.625 21.8047L20.3203 18.5L23.625 15.1953C24.3281 14.5625 24.3281 13.5078 23.625 12.8047C22.9922 12.1719 21.9375 12.1719 21.3047 12.8047L17.9297 16.1797L14.625 12.8047C13.9922 12.1719 12.9375 12.1719 12.3047 12.8047C11.6016 13.5078 11.6016 14.5625 12.3047 15.1953Z",
    fill: "#A8071A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/CrossCircle.72dbfe6102a4d821e8a10dcc843c7ba3.svg";
export { ForwardRef as ReactComponent };